/**
 * Generated by scripts/design-system/regenerate-design-system.cjs.
 * Source spec hash: 4b91f6a68eb56575e112b2a00fcb982a646b9233866775f5377f5b42a842e636
 */
import { css } from 'styled-components'

export default css`
  width: 320px;

  &.isFooterAbsolute {
    max-height: 320px;
  }
`
